import { render } from "./BlogTagPosts.vue?vue&type=template&id=82aaab7e&ts=true"
import script from "./BlogTagPosts.vue?vue&type=script&lang=ts"
export * from "./BlogTagPosts.vue?vue&type=script&lang=ts"

import "./BlogTagPosts.vue?vue&type=style&index=0&id=82aaab7e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__